module.exports = __webpack_public_path__ + "img/Ad_Ibsf.a94bbb74.png";